import { ExcelTest } from '../../2_domain/admin/excelTest';
import IAdminRepository from '../../2_domain/admin/iAdminRepository';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import Connection2 from '../core/connection2';
import { CREATE_CLINIC_ACCOUNT } from './adminQuery';

class AdminRepository implements IAdminRepository {
  // LINK -  id 67
  getAllExcelTests = async (): Promise<ExcelTest[]> => {
    const { code, ...res } = await Connection2.requestGet(
      'clinic/pass/queryExcelChart'
    );
    return res;
  };

  //LINK -  id 6
  //NOTE - NA
  createClinicAccount = async (
    email: string,
    password: string
  ): Promise<void> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    await client.mutate({
      mutation: CREATE_CLINIC_ACCOUNT,
      fetchPolicy: 'no-cache',
      variables: {
        input: {
          identifier: email,
          password: password,
        },
      },
    });
    return;
  };
}

export default AdminRepository;
